
import Layout from "@/components/Layout";
import TermsContent from "@/components/legal/TermsContent.tsx";

const TermsPage = () => {
  return (
    <Layout>
      <TermsContent />
    </Layout>
  );
};

export default TermsPage;
